// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3rhFW","loader":"styles_loader__3cvz0","load7":"styles_load7__2D-h7"};